import type { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { twMerge } from 'tailwind-merge'
import DangerIcon from 'shared/icons/danger-icon'

interface AttachmentFailedPreviewProps {
  className?: string
}

const AttachmentFailedPreview = ({ className }: AttachmentFailedPreviewProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <div
      className={twMerge(
        `flex h-full max-w-36 flex-col items-center justify-center gap-1 rounded-lg border border-text-secondary/30 p-5`,
        className,
      )}
    >
      <DangerIcon />
      <span className="text-center text-sm text-text-secondary">
        {t('post.attachments.file_upload_failed')}
      </span>
    </div>
  )
}

export default AttachmentFailedPreview
